import { StoreProvider } from "./store/Provider";
import Navigation from "./route/Navigation";
import { NotificationContainer } from "react-notifications";
import { OmsStoreProvider } from "./order_managment/store";
import "react-notifications/lib/notifications.css";

import "./App.css";
export default function App() {
  return (
    <StoreProvider>
      <OmsStoreProvider>
        <NotificationContainer />
        <Navigation />
      </OmsStoreProvider>
    </StoreProvider>
  );
}
